
import { Component, Vue } from "vue-property-decorator";
import firebase from "firebase/app";
import 'firebase/firebase-messaging';
import 'firebase/firebase-app';
import NotificationService from "../../../services/notificationService";

@Component
export default class Notifications extends Vue {
    test : string ='';
    userId: number;
    token: string = '';
 $loading: any;
     responseDataArray = [];
  fcmToken: string ='';
  bearerToken: string = localStorage.getItem("bearerToken");
  profileId: number;
  empId: number;
  loginType: string;

created()
{
    // this.fcmToken = localStorage.getItem("fcmtoken");
    // //this.bearerToken = localStorage.getItem("bearerToken");
    // this.profileId = Number(localStorage.getItem("profileId"));
    // this.loginType = localStorage.getItem("loginType");
    // this.empId = Number(localStorage.getItem("empId"));

    //   let userId;
    //     if(this.loginType == 'employer')
    //   {
    //     userId = this.empId;
    //   }
    //   else if(this.loginType == 'jobseeker')
    //   {
    //     userId = this.profileId;
    //   }
    //   console.log("this.bearerToken "+this.bearerToken)
    //   if(this.bearerToken != null && this.bearerToken != '')
    //   {
    //       let data = {
    //         userId: userId,
    //         token: this.fcmToken,
    //         userType: this.loginType.toUpperCase()
    //       };
    //       let loader = this.$loading.show();
    //       NotificationService.updateOrCreateToken(
    //             data
    //           ).then((data) => {
    //             loader.hide();
    //             if (data != undefined && data.data != undefined) {
    //               if (data.data.status == 200) {
                
    //               } 
    //             }
    //       });
    //   }
  }

}
